import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS, Validator, FormControl, ValidatorFn} from '@angular/forms';

@Directive({
  selector: '[ldHomeStateValidator][ngModel],[ldHomeStateValidator],[ldHomeStateValidator][formControl]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => HomeStateValidatorDirective), multi: true}
  ]
})
export class HomeStateValidatorDirective implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = validateHomeState;
  }

  validate(c: FormControl) {
    return this.validator(c);
  }
}

export function validateHomeState(control: FormControl) {
  let state = control.value;

  // value not equal
  if (window.location.href.indexOf('personal-loans') > -1 && state === 'WV') {
    return {
      invalidState: 'Enter a state.'
    };
  }

  return null;
}
